"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularButton = void 0;
var React = require("react");
var Icon_1 = require("../../Icons/Icon/Icon");
var CircularButton_styles_1 = require("./CircularButton.styles");
var CircularButton = function (_a) {
    var _b = _a.Disabled, Disabled = _b === void 0 ? false : _b, OnClick = _a.OnClick, AriaLabel = _a.AriaLabel, IconSelected = _a.Icon, Caption = _a.Caption;
    var _c = React.useState(false), hovered = _c[0], setHovered = _c[1];
    return (React.createElement(CircularButton_styles_1.Button, { onPointerOver: function () { return setHovered(true); }, onPointerOut: function () { return setHovered(false); }, type: "button", disabled: Disabled, onClick: OnClick, "aria-label": AriaLabel },
        React.createElement(CircularButton_styles_1.ContainerDiv, null,
            React.createElement(CircularButton_styles_1.IconContainerDiv, { Hovered: hovered }, IconSelected && React.createElement(Icon_1.Icon, { Icon: IconSelected, Height: "18px", Width: "18px" })),
            Caption && React.createElement(CircularButton_styles_1.CaptionDiv, null, Caption))));
};
exports.CircularButton = CircularButton;
